module.exports = __webpack_public_path__ + "img/Patrick_Loves_You.7499a44b.gif";